/**
 * @generated SignedSource<<2f4c031176e345103d0362ba45bc8f49>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SendInsightShareEmailInput = {
  insightShareId?: string | null;
  emails: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type sendInsightShareEmailMutation$variables = {
  input: SendInsightShareEmailInput;
};
export type sendInsightShareEmailMutation$data = {
  readonly sendInsightShareEmail: {
    readonly viewer: {
      readonly id: string;
    } | null;
  } | null;
};
export type sendInsightShareEmailMutation = {
  variables: sendInsightShareEmailMutation$variables;
  response: sendInsightShareEmailMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SendInsightShareEmailPayload",
    "kind": "LinkedField",
    "name": "sendInsightShareEmail",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "sendInsightShareEmailMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "sendInsightShareEmailMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e02b6a2989d01a09599afe1fa806715a",
    "id": null,
    "metadata": {},
    "name": "sendInsightShareEmailMutation",
    "operationKind": "mutation",
    "text": "mutation sendInsightShareEmailMutation(\n  $input: SendInsightShareEmailInput!\n) {\n  sendInsightShareEmail(input: $input) {\n    viewer {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "81fbc49baf50bab486fb23f8db97c57e";

export default node;
